var _path, _path2, _path3, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBeret = function SvgBeret(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 39,
    viewBox: "0 0 69 39",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0407406 26.8846C-0.620051 18.2937 6.9029 18.0091 12.0407 15.3846C20.243 11.1947 30.365 6.64482 35.0407 6.8846C54.5407 7.88461 54.5407 12.3846 63.5407 19.3846C74.4693 27.8846 64.8741 29.2179 56.5408 38.3846C54.5408 36.3846 52.0407 33.6346 46.5407 30.8846C39.5407 27.3846 35.5407 27.3846 30.0407 27.8846C25.0612 28.3373 17.0408 29.8846 10.5408 36.8846C7.37411 34.8846 0.540706 33.3846 0.0407406 26.8846Z",
    fill: "#CF425C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0407406 26.8846C-0.620051 18.2937 6.9029 18.0091 12.0407 15.3846C20.243 11.1947 30.365 6.64482 35.0407 6.8846C54.5407 7.88461 54.5407 12.3846 63.5407 19.3846C74.4693 27.8846 64.8741 29.2179 56.5408 38.3846C54.5408 36.3846 52.0407 33.6346 46.5407 30.8846C39.5407 27.3846 35.5407 27.3846 30.0407 27.8846C25.0612 28.3373 17.0408 29.8846 10.5408 36.8846C7.37411 34.8846 0.540706 33.3846 0.0407406 26.8846Z",
    fill: "url(#paint0_linear)",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5407 1.88461C34.7407 2.28461 34.374 5.71795 34.0407 7.38461C34.374 7.55128 34.7877 7.64356 35.0406 6.88461C36.0406 3.88461 35.0407 2.55128 35.0407 0.884613C34.0407 1.05128 32.3407 1.48461 33.5407 1.88461Z",
    fill: "#CF425C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 33.5,
    y1: 31.3846,
    x2: 34,
    y2: 7.88461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F0E0E",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBeret, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/beret.e59eda41.svg";
export { ForwardRef as ReactComponent };